import { UIText3 } from '@cian/ui-kit';
import { IconProductDocumentsVerified12 } from '@cian/ui-kit-design-tokens/icons';

import { type MouseEvent, type ReactNode, useCallback } from 'react';

import { RowWithFade } from '../../../../components/RowWithFade';

import styles from './PublisherNarrow.css';

type TPublisherNarrowProps = {
  name: string;
  url?: string;
  documentsChecked?: boolean;
  publicationDate: ReactNode;
};

export function PublisherNarrow({ name, url, documentsChecked, publicationDate }: TPublisherNarrowProps): ReactNode {
  const handleClick = useCallback(
    (e: MouseEvent<HTMLAnchorElement>) => {
      if (!url) {
        e.preventDefault();
      } else {
        e.stopPropagation();
      }
    },
    [url],
  );

  return (
    <div className={styles['container']}>
      <RowWithFade>
        <a className={styles['publisher']} href={url} onClick={handleClick}>
          {documentsChecked && (
            <div className={styles['documents-verified']}>
              <IconProductDocumentsVerified12 color="accent-main-primary" />
            </div>
          )}
          <div className={styles['name']} data-testid="card.author" title={name}>
            <UIText3 color="current_color">{name}</UIText3>
          </div>
        </a>
      </RowWithFade>

      {publicationDate}
    </div>
  );
}
